import React from 'react';

export default function Footer() {
    return (
        <React.Fragment>
            <>
                <section className="bg-coolGray-900" style={{ backgroundImage: 'url("flex-ui-assets/elements/pattern-dark.svg")', backgroundPosition: 'center' }}>
                    <div className="container px-4 mx-auto">
                        <div className="flex flex-wrap pt-24 pb-12 -mx-4">
                            <div className="w-full md:w-1/2 lg:w-6/12 px-4 mb-16 lg:mb-0">
                                <h3 className="mb-5 text-lg font-bold text-white">Contact Us</h3>
                                <p className="text-base md:text-xl text-coolGray-400 font-medium mb-4">Bagga International</p>
                                <ul>
                                    <li className="mb-4 text-coolGray-400 font-medium">21, Phase -1, HSIIDC,
                                        Gurgaon - 122016, Haryana,  INDIA</li>
                                    <li className="mb-4 text-coolGray-400 font-medium">Email: rajinderbagga@baggainternational.com / chiragbagga@baggainternational.com</li>
                                    <li className="mb-4 text-coolGray-400 font-medium">Whatsapp: +91-9811016163 / +91-9911016163</li>
                                </ul>
                            </div>
                            <div className="w-full md:w-1/4 lg:w-4/12 px-4 mb-16 lg:mb-0">
                                <h3 className="mb-5 text-lg font-bold text-white">Product Range</h3>
                                <ul>
                                    {require('../../data/categories.json').categories.slice(0, 3).map(category => (
                                        <li key={category.id} className="mb-4">
                                            <a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href={`/categories/${category.id}`}>{category.name}</a>
                                        </li>
                                    ))}
                                    <li>
                                        <a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href="/categories">See All</a>
                                    </li>
                                </ul>
                            </div>
                            <div className="w-full md:w-1/4 lg:w-2/12 px-4 mb-16 lg:mb-0">
                                <h3 className="mb-5 text-lg font-bold text-white">Links</h3>
                                <ul>
                                    <li className="mb-4"><a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href="/">Home</a></li>
                                    <li className="mb-4"><a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href="/about-us">About Us</a></li>
                                    <li className="mb-4"><a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href="/contact">Contact</a></li>
                                    <li className="mb-4"><a className="inline-block text-coolGray-400 hover:text-coolGray-500 font-medium" href="/blog">Blogs</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="border-b border-coolGray-800" />
                    <div className="container px-4 mx-auto py-10 md:pb-16">
                        <div className="flex flex-wrap justify-between items-center text-sm text-coolGray-400 font-medium pr-18">
                            <span>© Bagga International 2025. All Right Reserved.</span>
                            <span className="block pt-8 sm:pt-0">Web design by <a href="https://www.stunningweb.site" target="_blank" rel="noopener noreferrer" className="underline text-coolGray-400 hover:text-coolGray-500 font-medium">StunningWeb.Site</a></span>
                        </div>
                    </div>
                </section>
            </>
        </React.Fragment>
    );
} 